var _defs, _g, _ellipse, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgTimeRangePicker = function SvgTimeRangePicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "time-range-picker_svg__time-range-picker_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 511.46 512.96"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "time-range-picker_svg__time-range-picker_svg__defs12"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "time-range-picker_svg__time-range-picker_svg__linearGradient48782"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "time-range-picker_svg__time-range-picker_svg__stop48778",
    offset: 0,
    stopColor: "#000",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "time-range-picker_svg__time-range-picker_svg__stop48780",
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "time-range-picker_svg__time-range-picker_svg__linearGradient48784",
    x1: 232.112,
    x2: 316.681,
    y1: 192.273,
    y2: 192.273,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#time-range-picker_svg__time-range-picker_svg__linearGradient48782"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      lineHeight: 1.25,
      InkscapeFontSpecification: "'Google Sans Bold'"
    },
    id: "time-range-picker_svg__time-range-picker_svg__text50560",
    x: 245.125,
    y: 462.343,
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 0.579,
    fontFamily: "Google Sans",
    fontSize: 26.667,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 700,
    letterSpacing: 0,
    wordSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "time-range-picker_svg__time-range-picker_svg__tspan50558",
    x: 245.125,
    y: 462.343,
    style: {
      InkscapeFontSpecification: "'Google Sans Bold'"
    },
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 0.579,
    fontFamily: "Google Sans",
    fontSize: 26.667,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 700
  }, "12")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      lineHeight: 1.25,
      InkscapeFontSpecification: "'Google Sans Bold'"
    },
    id: "time-range-picker_svg__time-range-picker_svg__text50564",
    x: 447.372,
    y: 268.26,
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 0.579,
    fontFamily: "Google Sans",
    fontSize: 26.667,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 700,
    letterSpacing: 0,
    wordSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "time-range-picker_svg__time-range-picker_svg__tspan50562",
    x: 447.372,
    y: 268.26,
    style: {
      InkscapeFontSpecification: "'Google Sans Bold'"
    },
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 0.579,
    fontFamily: "Google Sans",
    fontSize: 26.667,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 700
  }, "6")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      lineHeight: 1.25,
      InkscapeFontSpecification: "'Google Sans Bold'"
    },
    id: "time-range-picker_svg__time-range-picker_svg__text50568",
    x: 249.256,
    y: 73.683,
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 0.579,
    fontFamily: "Google Sans",
    fontSize: 26.667,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 700,
    letterSpacing: 0,
    wordSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "time-range-picker_svg__time-range-picker_svg__tspan50566",
    x: 249.256,
    y: 73.683,
    style: {
      InkscapeFontSpecification: "'Google Sans Bold'"
    },
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 0.579,
    fontFamily: "Google Sans",
    fontSize: 26.667,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 700
  }, "0")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time-range-picker_svg__time-range-picker_svg__g30142",
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 3,
    transform: "translate(0 1.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path390",
    d: "M395 396.36l4.36 4.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path346",
    d: "M203.53 453.19l1.6-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path348",
    d: "M306.87 67.52l1.6-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path352",
    d: "M154.64 432.96l3.08-5.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path354",
    d: "M354.28 87.15l3.08-5.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path358",
    d: "M112.65 400.72l4.35-4.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path360",
    d: "M395 118.39l4.36-4.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path364",
    d: "M80.43 358.74l5.35-3.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path366",
    d: "M426.22 159.1l5.35-3.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path370",
    d: "M60.18 309.85l6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path372",
    d: "M445.86 206.5l6-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path376",
    d: "M60.18 204.96l6 1.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path378",
    d: "M445.86 308.25l6 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path382",
    d: "M80.43 156.01l5.35 3.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path384",
    d: "M426.22 355.65l5.35 3.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path388",
    d: "M112.65 114.03l4.36 4.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path394",
    d: "M154.64 81.81l3.08 5.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path396",
    d: "M354.28 427.6l3.08 5.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path400",
    d: "M203.53 61.56l1.6 6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path402",
    d: "M306.87 447.24l1.6 6"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "time-range-picker_svg__time-range-picker_svg__ellipse16",
    cx: 256,
    cy: 258.37,
    fill: "none",
    stroke: "#9196c5",
    strokeDasharray: "none",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 14,
    rx: 234.98,
    ry: 235.78
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__ellipse26000",
    fill: "none",
    stroke: "#7151d9",
    strokeDasharray: "none",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 14,
    d: "M415 431.946c48.414-44.644 75.972-107.6 75.98-173.576 0-130.218-105.204-235.78-234.98-235.78"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      InkscapeFontSpecification: "'Google Sans'"
    },
    id: "time-range-picker_svg__time-range-picker_svg__text470",
    x: 231.397,
    y: 198.422,
    fill: "url(#time-range-picker_svg__time-range-picker_svg__linearGradient48784)",
    fillOpacity: 1,
    strokeWidth: 1.127,
    fontFamily: "Google Sans",
    fontSize: 23.836,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      InkscapeFontSpecification: "'Google Sans'"
    },
    id: "time-range-picker_svg__time-range-picker_svg__tspan48786",
    fill: "#000",
    fillOpacity: 1,
    fontFamily: "Google Sans",
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400
  }, "Sleep at")), /*#__PURE__*/React.createElement("text", {
    style: {
      InkscapeFontSpecification: "'Google Sans'"
    },
    id: "time-range-picker_svg__time-range-picker_svg__text482",
    x: 238.029,
    y: 241.287,
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 1.127,
    fontFamily: "Google Sans",
    fontSize: 33.487,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400
  }, "0:00"), /*#__PURE__*/React.createElement("text", {
    style: {
      InkscapeFontSpecification: "'Google Sans'"
    },
    id: "time-range-picker_svg__time-range-picker_svg__text484",
    x: 238.565,
    y: 334.057,
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 1.127,
    fontFamily: "Google Sans",
    fontSize: 33.487,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    letterSpacing: ".02em"
  }, "9:00"), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path486",
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 1.134,
    d: "M205.97 200.17l-3.617 2.767 1.304 4.375-3.752-2.584-3.764 2.584 1.304-4.375-3.616-2.766 4.534-.136 1.519-4.285 1.507 4.285 4.535.136m4.999 9.873l-2.335 1.78.839 2.834L207 212.98l-2.437 1.678.85-2.834-2.301-1.791 2.947-.08.986-2.777.986 2.777 2.936.08m-3.253 7.073c1.19-.113 2.46 1.565 1.7 2.642a12.107 12.107 0 01-1.541 1.813 14.284 14.284 0 01-20.2-20.2 13.83 13.83 0 011.813-1.553c1.065-.748 2.755.521 2.641 1.7a14.317 14.317 0 0015.587 15.598m-2.347 2.88a17.004 17.004 0 01-16.13-16.131 11.426 11.426 0 0016.13 16.13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path488",
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 1.15,
    d: "M198.086 316.481a10.351 10.351 0 1110.35-10.351 10.351 10.351 0 01-10.35 10.351m0-23.727a13.353 13.353 0 1013.353 13.341 13.342 13.342 0 00-13.353-13.341m.747 5.935h-2.231v8.89l7.05 4.233 1.15-1.829-5.923-3.508v-7.786m-6.9-6.844l-1.898-2.3-6.832 5.75 1.92 2.301 6.81-5.75m20.943 3.45l-6.82-5.751-1.92 2.3 6.82 5.751z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "time-range-picker_svg__time-range-picker_svg__circle502",
    cx: 422.16,
    cy: 425.09,
    r: 22.5,
    fill: "#7151d9",
    fillOpacity: 1,
    strokeWidth: 1.115
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "time-range-picker_svg__time-range-picker_svg__circle506",
    cx: 255.32,
    cy: 22.5,
    r: 22.5,
    fill: "#7151d9",
    fillOpacity: 1,
    strokeWidth: 1.115
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path20",
    fill: "none",
    fillOpacity: 1,
    stroke: "#444973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: "M234.81 57.2l.64 6.14zm42.38 0l-.64 6.14zm-52.94 1.39l1 6.09zm63.46 0l-1 6.09zm10.44 1.93l-1.28 6zm-84.3.03l1.28 6zm-20.5 5.46l1.91 5.87zm125.3 0l-1.91 5.87zm-135.3 3.55l2.21 5.75zm145.3 0l-2.21 5.75zm-155.11 4.06l2.51 5.63zm164.92 0L336 79.25zM164 78.19l2.76 5.49zm184 0l-2.8 5.49zM145.64 88.8l3.36 5.17zm220.77 0l-3.36 5.17zm-229.57 6l3.63 5zm238.32.01l-3.63 5zm-246.74 6.46l3.88 4.79zm255.16 0l-3.88 4.79zm-263.23 6.89l4.13 4.59zm271.3 0l-4.13 4.59zm-286.3 15.01l4.58 4.12zm301.3 0l-4.58 4.12zm-308.2 8.07l4.8 3.88zm315.1 0l-4.8 3.88zM92 139.66l5 3.62zm328 0l-5 3.62zM86 148.4l5.15 3.36zm340 0l-5.17 3.36zM75.37 166.78l5.5 2.8zm361.26 0l-5.5 2.8zM70.8 176.4l5.64 2.47zm370.4 0l-5.64 2.51zm4.06 9.77l-5.76 2.23zm-378.52.02l5.76 2.21zm-3.54 9.98l5.86 1.91zm385.6 0l-5.86 1.91zm-391.06 20.5l6 1.28zm396.56 0l-6 1.28zm-398.53 10.4l6.09 1zm400.46.03l-6.09 1zM54.39 237.63l6.13.64zm403.22 0l-6.13.64zm-6.13 41.73l6.13.65zm-390.96.04l-6.13.65zm389.62 10.13l6.09 1zm-388.28.03l-6.09 1zm1.88 10.12l-6 1.29zm384.56 0l6 1.29zM69.06 319.56l-5.86 1.9zm373.88 0l5.86 1.9zm-370.44 9.7l-5.76 2.21zm367 0l5.76 2.21zm-363.06 9.5l-5.64 2.51zm359.12 0l5.64 2.51zm-354.69 9.29l-5.5 2.8zm350.26 0l5.5 2.8zM91.15 365.87L86 369.23zm329.68 0l5.17 3.36zM97 374.4l-5 3.63zm318 0l5 3.58zm-311.75 8.11l-4.8 3.89zm305.5 0l4.8 3.89zm-298.82 7.83l-4.58 4.13zm292.14 0l4.58 4.13zm-277.59 14.55l-4.13 4.58zm263.04 0l4.13 4.58zm-255.22 6.68l-3.88 4.83zm247.4.04l3.88 4.791zm-8.17 6.21l3.63 5zm-231.06.01l-3.63 5zm8.53 5.831l-3.36 5.18zm214.05 0l3.36 5.18zm-196.29 10.29l-2.8 5.5zm178.44 0l2.8 5.5zm-169.15 4.45l-2.51 5.639zm159.95 0l2.46 5.62zm-150.44 3.92l-2.21 5.76zm140.88 0l2.21 5.76zm-131.18 3.43l-1.91 5.869zm121.48 0l1.91 5.869zm-101.61 5.33l-1.28 6zm81.74.03l1.28 6zm-71.62 1.839l-1 6.1zm61.46 0l1 6.1zm-10.16 1.32l.64 6.131zm-41.1.03l-.64 6.13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path486-9",
    fill: "#fff",
    d: "M263.03 13.17l-3.19 2.44 1.15 3.86-3.31-2.28-3.32 2.28 1.15-3.86-3.19-2.44 4-.12 1.34-3.78 1.33 3.78 4 .12m4.41 8.71l-2.06 1.57.74 2.5-2.14-1.48-2.15 1.48.75-2.5-2.03-1.58 2.6-.07.87-2.45.87 2.45 2.59.07m-2.87 6.24c1.05-.1 2.17 1.38 1.5 2.33a10.68 10.68 0 01-1.36 1.6 12.6 12.6 0 01-17.82-17.82 12.2 12.2 0 011.6-1.37c.94-.66 2.43.46 2.33 1.5a12.63 12.63 0 0013.75 13.76m-2.07 2.54a15 15 0 01-14.23-14.23 10.08 10.08 0 0014.23 14.23z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "time-range-picker_svg__time-range-picker_svg__path488-4",
    fill: "#fff",
    d: "M422.16 435.505a9 9 0 119-9 9 9 0 01-9 9m0-20.63a11.61 11.61 0 1011.61 11.6 11.6 11.6 0 00-11.61-11.6m.65 5.16h-1.94v7.73l6.13 3.68 1-1.59-5.15-3.05v-6.77m-6-5.95l-1.65-2-5.94 5 1.67 2 5.92-5m18.21 3l-5.93-5-1.67 2 5.93 5z"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      lineHeight: 1.25,
      InkscapeFontSpecification: "'Google Sans Bold'"
    },
    id: "time-range-picker_svg__time-range-picker_svg__text50556",
    x: 49.367,
    y: 268.26,
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 0.579,
    fontFamily: "Google Sans",
    fontSize: 26.667,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 700,
    letterSpacing: 0,
    wordSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "time-range-picker_svg__time-range-picker_svg__tspan50554",
    x: 49.367,
    y: 268.26,
    style: {
      InkscapeFontSpecification: "'Google Sans Bold'"
    },
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 0.579,
    fontFamily: "Google Sans",
    fontSize: 26.667,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 700
  }, "18")), /*#__PURE__*/React.createElement("text", {
    style: {
      InkscapeFontSpecification: "'Google Sans'"
    },
    id: "time-range-picker_svg__time-range-picker_svg__text60892",
    x: 231.648,
    y: 290.967,
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 1.127,
    fontFamily: "Google Sans",
    fontSize: 23.836,
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      InkscapeFontSpecification: "'Google Sans'"
    },
    id: "time-range-picker_svg__time-range-picker_svg__tspan60890",
    fill: "#000",
    fillOpacity: 1,
    fontFamily: "Google Sans",
    fontStretch: "normal",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400
  }, "Wake at")));
};

;
export default SvgTimeRangePicker;